import template from './thumbnail-cover.component.html';

export const mediaThumbnailCoverComponent = {
	template,
	require: {
		thumbnailCtrl: '^mediaThumbnail'
	}
} as ng.IComponentOptions;
